export function createArticleLink({ pii, doi, eid }) {
  if (pii) {
    return `${window.config.SDBaseUrl}/science/article/pii/${pii}`;
  }
  if (doi) {
    return `https://doi.org/${doi}`;
  }
  if (eid) {
    return `https://www.scopus.com/inward/record.url?eid=${eid}&partnerID=10&rel=R3.0.0`;
  }
  return null;
}

export function createDownloadLink(pdfPath) {
  return `${window.config.SDBaseUrl}${pdfPath}`;
}

export function createEprLink({ pii }) {
  return `${window.config.SDBaseUrl}/sdfe/reader/pii/${pii}/pdf`;
}

export function createAssetLink(filename) {
  return `${window.config.assetsBaseUrl}/content/image/${filename}`;
}

export function createDownloadAttachmentsLink(pii) {
  return `${window.config.SDBaseUrl}/sdfe/pdf/download/${pii}/attachments`;
}
